import styled, { css } from 'styled-components'
import { MOBILE_WIDTH } from 'utils/constants'
import { temporaryTheme } from 'styles/theme'

export const OrderDetailsContainer = styled.main`
  display: flex;
  flex-direction: column;

  width: 100%;
  background: #f7f7f7;
  padding: 2rem;

  border-radius: 0.5rem;

  @media ${MOBILE_WIDTH} {
    padding: 0.5rem;
  }
`

export const OrdersContainer = styled.section`
  display: flex;
  flex-direction: column;

  background: #e0e7ec;
  padding: 2rem;
  border-radius: 0.5rem;
`

export const PackageButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${temporaryTheme.colors.gray};
`

export const PackageButton = styled.button<{ isActive: boolean }>`
  background-color: white;
  color: ${temporaryTheme.colors.dark};
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px 4px 0 0;

  &:hover {
    background-color: #f0f0f0;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${temporaryTheme.colors.sitePrimary};
      border-bottom: 2px solid ${temporaryTheme.colors.sitePrimary};
      background-color: #e8f5f0;
    `}
`
